import React, { useState, useEffect, useCallback } from "react"
import { restartAllTsServers, startAllTsServers, stopAllTsServers } from "../services/serverApis"

import { useNavigate } from "react-router-dom"
import { APP_ROUTES } from "../utils/constants"
import getTimeDiffInDays from "../utils/getTimeDiffInDays"
import getTimeDiffFaString from "../utils/getTimeDiffFaString"
import Table from "../components/Table"
import actionHelper from "../lib/actionHelper"
import CreateServerModal from "../components/Servers/CreateServerModal"
import ServerMoreModal from "../components/Servers/ServerMoreModal"
import { toast } from "react-toastify"
import AutoRenewButton from "../components/Servers/AutoRenewButton"
import { useAuth } from "../lib/useAuth"
import { useSocket, useSocketEvent } from "../contexts/SocketContext"
import LogsModal from "../components/LogsModal"
import sidebarStore from "../store/sidebarStore"
import useLivePromise from "../lib/livePromise"

const cols = [
    {
        name: "حالت",
        colSpan: 1,
    },
    {
        name: "وضعیت",
        colSpan: 1,
    },
    {
        name: "سرورپورت",
        colSpan: 1,
    },
    {
        name: "کوئری‌پورت",
        colSpan: 1,
    },
    {
        name: "ساب‌دامین",
        colSpan: 1,
    },
    {
        name: "پسوردکوئری",
        colSpan: 1,
    },
    {
        name: "انقضا",
        colSpan: 1,
    },
    {
        name: "تمدید اتومات",
        colSpan: 1,
    },
    {
        name: "اسلات",
        colSpan: 1,
    },
    {
        name: "ورژن",
        colSpan: 1,
    },

    {
        name: "تنظیمات",
        colSpan: 1,
    },
]

const Index = () => {
    const { user, loading } = useAuth()
    const { isConnected, sendMessage } = useSocket()
    const navigate = useNavigate()
    const [allServers, setAllServers] = useState([])
    const [rows, setRows] = useState(null)
    const [selecteds, setSelecteds] = useState([])
    const [createIsOpen, setCreateIsOpen] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(null)
    const [searchBar, setSearchBar] = useState("")
    const [pagination, setPagination] = useState({})
    const setSection = sidebarStore((state) => state.setSection)

    const { run } = useLivePromise()

    const searchBarChangeHandler = async (e) => {
        await new Promise((resolve) => setTimeout(resolve, 500))
        setSearchBar(e.target.value)
        setCurrentPage(1)
    }

    const toggleCreate = () => {
        setCreateIsOpen(!createIsOpen)
    }

    const createRows = (servers) => {
        return servers?.map((server) => {
            const now = new Date()
            const createdDate = new Date(server.created)
            const expireDate = new Date(server.expires)
            const expiresInDays = server.expires == null ? null : getTimeDiffInDays(expireDate, now)
            server.expString = server.expires == null ? null : getTimeDiffFaString(expireDate, now)
            server.crtString = getTimeDiffFaString(createdDate, now)

            let obj = {
                id: server.id,
                state: (
                    <span className={server.state === "active" ? "bg-blur-success" : "bg-blur-warning"}>
                        {server.state === "active" ? "فعال" : "غیرفعال"}
                    </span>
                ),
                status: (
                    <span className={server.status == "online" ? "bg-blur-success" : "bg-blur-danger"}>
                        {server.status === "online" ? "روشن" : "خاموش"}
                    </span>
                ),
                server_port:
                    server.status === "online" ? (
                        <a className="text-blue-300" href={`ts3server://${user?.companyIp}?port=${server.server_port}`}>
                            {server.server_port}
                        </a>
                    ) : (
                        server.server_port
                    ),
                query_port: server.query_port,
                subdomain_name: server.subdomain_name
                    ? server.subdomain_name.length > 12
                        ? "..." + server.subdomain_name.slice(0, 12)
                        : server.subdomain_name
                    : "-------------",
                query_password: server.query_password,
                expString:
                    server.expires != null ? (
                        <span className={expiresInDays > 0 ? "text-success" : "text-danger"}>{server.expString}</span>
                    ) : (
                        <span>دائمی</span>
                    ),
                autorenew: <AutoRenewButton server={server} />,
                slots: server.slots,
                version: server.version,
                more: (
                    <div className="flex gap-2">
                        <ServerMoreModal server={server} />
                        <LogsModal service={{ en: "teamspeak", fa: "تیم اسپیک" }} id={server.id} />
                    </div>
                ),
            }
            return obj
        })
    }

    // Create stable callback functions for socket events
    const handleServerStatusUpdated = useCallback((payload) => {
        setAllServers((oldServers) => {
            return oldServers.map((s) => {
                if (s.id == payload.serverId) {
                    Object.assign(s, { status: payload.status, onlines: payload.onlines })
                }
                return s
            })
        })
    }, [])

    const handleServerList = useCallback((res) => {
        setPagination(res.pagination)
        setAllServers(res.data)
    }, [])

    const handleServerAdded = useCallback((newServer) => {
        setAllServers((serverList) => {
            return [...serverList, newServer]
        })
    }, [])

    const handleServerUpdated = useCallback((newData) => {
        setAllServers((oldServers) => {
            return oldServers.map((s) => {
                return s.id === newData.id ? Object.assign(s, newData) : s
            })
        })
    }, [])

    const handleServerDeleted = useCallback((deletedId) => {
        setAllServers((oldServers) => {
            return oldServers.filter((s) => s.id !== deletedId)
        })
    }, [])

    // Use the stable callbacks with socket events
    useSocketEvent("serverStatusUpdated", handleServerStatusUpdated)
    useSocketEvent("serverList", handleServerList)
    useSocketEvent("serverAdded", handleServerAdded)
    useSocketEvent("serverUpdated", handleServerUpdated)
    useSocketEvent("serverDeleted", handleServerDeleted)

    const multiTasking = {
        setSelecteds: setSelecteds,
        selecteds: selecteds,
        tasks: [
            {
                title: "روشن کردن",
                color: "success",
                icon: "play",
                onClick: () => {
                    if (selecteds.length !== 0) {
                        actionHelper({
                            confirmation: {
                                label: "ایا مطمئن هستید سرور های انتخاب شده را روشن کنید؟",
                                actionLabel: "روشن کردن",
                                color: "success",
                            },
                            callback: () => {
                                return startAllTsServers(selecteds.map((s) => s.id))
                            },
                            texts: { success: "استارت شد", pending: "درحال استارت" },
                        })
                    } else {
                        toast.error("سروری انتخاب نشده است")
                    }
                },
            },
            {
                title: "خاموش کردن",
                color: "danger",
                icon: "power-off",
                onClick: () => {
                    if (selecteds.length !== 0) {
                        actionHelper({
                            confirmation: {
                                label: "آیا مطمئن هستید سرور های انتخاب شده را خاموش کنید؟",
                                actionLabel: "خاموش کردن",
                                color: "danger",
                            },
                            callback: () => {
                                return stopAllTsServers(selecteds.map((s) => s.id))
                            },
                            texts: { success: "خاموش شد", pending: "درحال خاموش" },
                        })
                    } else {
                        toast.error("سروری انتخاب نشده است")
                    }
                },
            },
            {
                title: "ریستارت کردن",
                color: "border",
                icon: "repeat",
                onClick: () => {
                    if (selecteds.length !== 0) {
                        actionHelper({
                            confirmation: {
                                label: "ایا مطمئن هستید سرور های انتخاب شده را ریستارت کنید؟",
                                actionLabel: "ریستارت کردن",
                                color: "danger",
                            },
                            callback: () => {
                                return restartAllTsServers(selecteds.map((s) => s.id))
                            },
                            texts: { success: "ریستارت شد", pending: "درحال ریستارت" },
                        })
                    } else {
                        toast.error("سروری انتخاب نشده است")
                    }
                },
            },
        ],
    }

    const section = {
        title: "سرورها",
        setSearchBar: searchBarChangeHandler,
        buttons: [
            {
                name: "ساخت سرور جدید",
                onClick: toggleCreate,
                color: "border",
                iconName: "square-plus",
            },
            {
                name: "روشن کردن همه",
                onClick: () =>
                    actionHelper({
                        confirmation: {
                            label: "ایا مطمئن هستید همه ی سرور ها را روشن کنید؟",
                            actionLabel: "روشن کردن",
                            color: "success",
                        },
                        callback: () =>
                            run({
                                job: () => startAllTsServers(),
                                subscribeEvent: "server_start_all_progress",
                                doneEvent: "server_start_all_done",
                                correlationId: "start_all_servers",
                                initialPending: "در حال روشن کردن همه سرور ها",
                            }),
                    }),
                color: "success",
                iconName: "play",
            },
            {
                name: "ریستارت همه",
                onClick: () =>
                    actionHelper({
                        confirmation: {
                            label: "ایا مطمئن هستید همه ی سرور ها را ریستارت کنید؟",
                            actionLabel: "ریستارت کردن",
                            color: "warning",
                        },
                        callback: () => {
                            return restartAllTsServers()
                        },
                        texts: { success: "ریستارت شد", pending: "درحال ریستارت" },
                    }),
                color: "warning",
                iconName: "repeat",
            },
            {
                name: "خاموش کردن همه",
                onClick: () =>
                    actionHelper({
                        confirmation: {
                            label: "ایا مطمئن هستید همه ی سرور ها را خاموش کنید؟",
                            actionLabel: "خاموش کردن",
                            color: "danger",
                        },
                        callback: () => {
                            return stopAllTsServers()
                        },
                        texts: { success: "خاموش شد", pending: "درحال خاموش" },
                    }),
                color: "danger",
                iconName: "power-off",
            },
        ],
    }
    const handleRefresh = () => {
        sendMessage("getServerList", { rowsPerPage, currentPage })
    }

    useEffect(() => {
        if ((loading && !isConnected) || !rowsPerPage) {
            return
        }
        if (user && user.can_use_servers) {
            console.log(rowsPerPage, currentPage, searchBar)
            sendMessage("getServerList", { rowsPerPage, currentPage, searchBar })
        } else if (user && user.can_use_bot) {
            navigate(APP_ROUTES.MUSIC_BOTS)
        } else if (user && user.can_use_manager_bots) {
            navigate(APP_ROUTES.TS_MANAGER_BOTS)
        } else if (user) {
            toast.error("شما هیچگونه دسترسی ندارید")
            localStorage.clear()
            navigate(APP_ROUTES.SIGN_IN)
        } else {
            return
        }
    }, [loading, isConnected, sendMessage, rowsPerPage, currentPage, searchBar])

    useEffect(() => {
        if (allServers) {
            setRows(createRows(allServers))
        }
    }, [allServers])

    useEffect(() => {
        setSection(section)
    }, [])

    if (!user) {
        return <div>...در حال بارگذاری</div>
    }

    return (
        <>
            <CreateServerModal isOpen={createIsOpen} toggleModal={toggleCreate} />
            <Table
                cols={cols}
                rows={rows}
                paging={{ setRowsPerPage, setCurrentPage }}
                pagination={pagination}
                multiTasking={multiTasking}
                handleRefresh={handleRefresh}
            />
        </>
    )
}

export default Index
